import { useContext } from "react";
import userContext from "./context.js";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
export default function Withdraw(){
    let user = useContext(userContext);
    let len=user.users.length
  let [currbalance, setCurrbalance] = useState(user.users[len-1].balance);
  let [withdraw, setWithdraw] = useState(0);

  function handleSubmit(e) {
    e.preventDefault();
    // console.log("withdraw", withdraw);
    if(withdraw<=0 && withdraw){
      alert("please Enter a valid amount")
  }else if(withdraw>currbalance){
    alert("Insufficient Balance")
  }else{
    alert(`₹${withdraw} Withdraw Successfully`)
    setCurrbalance(Number(currbalance) - Number(withdraw));
  }
}
  user.users[len-1].balance = currbalance;
    return(
    <div id="withdraw">
            <Card id="form-card">
    <form onSubmit={handleSubmit}>
        <h1>Withdraw </h1><br />
      <h3>Available Balance : {currbalance} </h3><br />
        <input type="number" onChange={(e) => setWithdraw(e.target.value)} />
        <Button type="submit" disabled={!(withdraw)}><b>Submit</b></Button>
      </form>
      </Card>
    </div>
    )
}


